import Vue from "vue";
import Router from "vue-router";
import {
  AuthenticationGuard,
  GuestGuard,
} from "@/app/authentication/authentication.guard";
import Authentication from "@/app/authentication/Authentication";
import ForgetPassword from "@/app/authentication/ForgetPassword";
import ResetPassword from "@/app/authentication/ResetPassword";
import NotFound from "@/errors/NotFound";
import AddressComponent from "@/app/components/AddressComponent";
import HomeComponent from "@/app/home/HomeComponent";
import AboutComponent from "@/app/about/About";
import DashboardComponent from "@/app/home/dashboard/DashboardComponent";
import InvoicesComponent from "@/app/home/invoices/InvoicesComponent";
import InvoicesAddComponent from "@/app/home/invoices/InvoicesAddComponent";
import PrizesComponent from "@/app/home/prizes/PrizesComponent";
import PrizeCategoryComponent from "@/app/home/prizes/PrizeCategoryComponent";
import PrizeGroupComponent from "@/app/home/prizes/PrizeGroupComponent";
import MyPrizesComponent from "@/app/home/prizes/MyPrizesComponent";
import PrizeComponent from "@/app/home/prizes/PrizeComponent";
import PointsComponent from "@/app/home/points/PointsComponent";
import MoneysComponent from "@/app/home/moneys/MoneysComponent";
import CalendarComponent from "@/app/home/calendar/CalendarComponent";
import StationaryTrainingComponent from "@/app/home/calendar/StationaryTrainingComponent";
import OnlineTrainingComponent from "@/app/home/calendar/OnlineTrainingComponent";

import ProfileComponent from "@/app/home/user/ProfileComponent";
import ChangePasswordComponent from "@/app/home/user/ChangePasswordComponent";
import TrainingComponent from "@/app/home/training/TrainingComponent";
import NewsListComponent from "@/app/home/news/NewsListComponent";
import NewsComponent from "@/app/home/news/NewsComponent";
import SpecialActionsListComponent from "@/app/home/specialActions/SpecialActionsListComponent";
import SpecialActionsComponent from "@/app/home/specialActions/SpecialActionsComponent";
import QuizesComponent from "@/app/home/quizes/QuizesComponent";
import QuizComponent from "@/app/home/quizes/QuizComponent";
import QuizSolveComponent from "@/app/home/quizes/QuizSolveComponent";
import ToolsComponent from "@/app/home/tools/ToolsComponent";
import ToolComponent from "@/app/home/tools/ToolComponent";
import MyToolsComponent from "@/app/home/tools/MyToolsComponent";
import ToolsWidget from "@/app/home/tools/ToolsWidget";

import AdviceComponent from "@/app/home/advices/AdviceComponent";
import AdvicesComponent from "@/app/home/advices/AdvicesComponent";
import CategoriesComponent from "@/app/home/files/CategoriesComponent";
import FilesComponent from "@/app/home/files/FilesComponent";
import InstalatorPrizesComponent from "@/app/home/instalatorPrizes/InstalatorPrizesComponent";
import InstalatorMyPrizesComponent from "@/app/home/instalatorPrizes/InstalatorMyPrizesComponent";
import InstalatorPrizeComponent from "@/app/home/instalatorPrizes/InstalatorPrizeComponent";
import WelcomeComponent from "@/app/components/WelcomeComponent";
import ContactComponent from "@/app/home/contact/ContactComponent";
import RulesComponent from "@/app/home/rules/RulesComponent";
import ContractsComponent from "@/app/home/contracts/ContractsComponent";

import HeaderComponent from "@/app/home/HeaderComponent";
import FooterComponent from "@/app/home/FooterComponent";

import CalendarWidget from "@/app/home/calendar/CalendarWidget";
import WebinarWidget from "@/app/home/webinar/WebinarWidget";

import InvoicesWidget from "@/app/home/invoices/InvoicesWidget";
import PrizesWidget from "@/app/home/prizes/PrizesWidget";
import PointsWidget from "@/app/home/points/PointsWidget";
import KnowledgeWidget from "@/app/home/knowledge/KnowledgeWidget";
import TrainingWidget from "@/app/home/training/TrainingWidget";
import MoneysWidget from "@/app/home/moneys/MoneysWidget";
import NewsWidget from "@/app/home/news/NewsWidget";
import CertyficateWidget from "@/app/home/certyficates/CertyficateWidget";
import SpecialActionsWidget from "@/app/home/specialActions/SpecialActionsWidget";
import ContactWidget from "@/app/home/contact/ContactWidget";
import ContactBox from "@/app/home/contact/ContactBox";
import PrizesList from "@/app/home/prizes/PrizesListComponent";
import UserPointsInfoWidget from "@/app/home/prizes/UserPointsInfoWidget";
import RulesWidget from "@/app/home/rules/RulesWidget";

import MainBoxSetWidget from "@/app/home/boxSets/MainBoxSetWidget";
import PageBoxSetWidget from "@/app/home/boxSets/PageBoxSetWidget";
import Register from "../app/authentication/Register.vue";
import RegisterQuestions from "../app/authentication/RegisterQuestions.vue";

Vue.component("HeaderComponent", HeaderComponent);
Vue.component("FooterComponent", FooterComponent);
Vue.component("CalendarWidget", CalendarWidget);
Vue.component("WebinarWidget", WebinarWidget);

Vue.component("InvoicesWidget", InvoicesWidget);
Vue.component("PrizesWidget", PrizesWidget);
Vue.component("PointsWidget", PointsWidget);
Vue.component("KnowledgeWidget", KnowledgeWidget);
Vue.component("TrainingWidget", TrainingWidget);
Vue.component("MoneysWidget", MoneysWidget);
Vue.component("CertyficateWidget", CertyficateWidget);
Vue.component("NewsWidget", NewsWidget);
Vue.component("ContactWidget", ContactWidget);
Vue.component("ToolsWidget", ToolsWidget);

Vue.component("ContactBox", ContactBox);
Vue.component("PrizesList", PrizesList);

Vue.component("UserPointsInfoWidget", UserPointsInfoWidget);
Vue.component("RulesWidget", RulesWidget);

Vue.component("MainBoxSetWidget", MainBoxSetWidget);
Vue.component("PageBoxSetWidget", PageBoxSetWidget);

Vue.use(Router);

export default new Router({
  // mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "Welcome",
      component: WelcomeComponent,
      beforeEnter: GuestGuard,
      meta: {
        title: "GeberitPro",
      },
    },
    {
      path: "/o-programie",
      name: "About",
      component: AboutComponent,
      beforeEnter: GuestGuard,
      meta: {
        title: "GeberitPro - o programie",
      },
    },
    {
      path: "/dodaj-dowod-zakupu",
      name: "InvoicesAddAsGuest",
      component: InvoicesAddComponent,
      beforeEnter: GuestGuard,
      meta: {
        title: "Dodaj dowód zakupu",
      },
    },
    {
      path: "/adres",
      name: "Address",
      component: AddressComponent,
      beforeEnter: AuthenticationGuard,
      meta: {
        title: "Dane adresowe",
      },
    },
    {
      path: "/",
      component: HomeComponent,
      beforeEnter: AuthenticationGuard,
      children: [
        {
          path: "/dashboard",
          name: "Dashboard",
          component: DashboardComponent,
          meta: {
            title: "Strona główna",
          },
        },
        {
          path: "/faktury",
          name: "Invoices",
          component: InvoicesComponent,
          meta: {
            title: "Faktury - lista",
          },
        },
        {
          path: "/faktury/dodaj",
          name: "InvoicesAdd",
          component: InvoicesAddComponent,
          meta: {
            title: "Faktury - dodaj",
          },
        },
        /* Widok Nagrody z pasku nawigacji */
        {
          path: "/nagrody",
          name: "Prizes",
          component: PrizesComponent,
          meta: {
            title: "Nagrody",
          },
        },
        /* Wyświetlanie pojedynczej nagrody */
        {
          path: "/nagrody/:id",
          name: "Prize",
          component: PrizeComponent,
          meta: {
            title: "Nagrody",
          },
        },
        /* wyświetlanie kategorii */
        {
          path: "/kategoria/:contest_id/:prize_group_id",
          name: "PrizeGroup",
          component: PrizeGroupComponent,
          meta: {
            title: "Nagrody",
          },
        },
        {
          path: "/kategoria/:contest_id/:prize_group_id/:prize_category_id",
          name: "PrizeCategory",
          component: PrizeCategoryComponent,
          meta: {
            title: "Nagrody Grupy",
          },
        },
        {
          path: "/zamowione-nagrody",
          name: "MyPrizes",
          component: MyPrizesComponent,
          meta: {
            title: "Zamówione nagrody",
          },
        },
        {
          path: "/szkolenia",
          name: "Calendar",
          component: CalendarComponent,
          meta: {
            title: "Szkolenia",
          },
        },
        {
          path: "/szkolenia-stacjonarne",
          name: "StationaryTraining",
          component: StationaryTrainingComponent,
          meta: {
            title: "Szkolenia stacjonarne",
          },
        },
        {
          path: "/szkolenia-online",
          name: "OnlineTraining",
          component: OnlineTrainingComponent,
          meta: {
            title: "Szkolenia online",
          },
        },
        {
          path: "/szkolenie/:id",
          name: "Training",
          component: TrainingComponent,
          meta: {
            title: "Szkolenie",
          },
        },
        {
          path: "/profil",
          name: "Profile",
          component: ProfileComponent,
          meta: {
            title: "Profil",
          },
        },
        {
          path: "/zmiana-hasla",
          name: "ChangePassword",
          component: ChangePasswordComponent,
          meta: {
            title: "Zmiana hasła",
          },
        },
        {
          path: "/punkty",
          name: "PointsHistory",
          component: PointsComponent,
          meta: {
            title: "Historia punktów",
          },
        },
        {
          path: "/zlotowki",
          name: "MoneysHistory",
          component: MoneysComponent,
          meta: {
            title: "Historia złotówek",
          },
        },
        {
          path: "/aktualnosci",
          name: "NewsList",
          component: NewsListComponent,
          meta: {
            title: "Aktualności",
          },
        },
        {
          path: "/aktualnosci/:id",
          name: "News",
          component: NewsComponent,
          meta: {
            title: "Aktualności",
          },
        },
        {
          path: "/promocje-specjalne",
          name: "SpecialActionsList",
          component: SpecialActionsListComponent,
          meta: {
            title: "Promocje Specjalne",
          },
        },
        {
          path: "/promocje-specjalne/:id",
          name: "SpecialActions",
          component: SpecialActionsComponent,
          meta: {
            title: "Promocje Specjalne",
          },
        },
        {
          path: "/zasady",
          name: "Rules",
          component: RulesComponent,
          meta: {
            title: "Zasady programu",
          },
        },
        {
          path: "/umowy",
          name: "Contracts",
          component: ContractsComponent,
          meta: {
            title: "Umowy odrókowe",
          },
        },
        {
          path: "/quizy",
          name: "Quizes",
          component: QuizesComponent,
          meta: {
            title: "Quizy",
          },
        },
        {
          path: "/quizy/zobacz/:id",
          name: "Quiz",
          component: QuizComponent,
          meta: {
            title: "Quizy",
          },
        },
        {
          path: "/quizy/rozwiaz/:id",
          name: "QuizSolve",
          component: QuizSolveComponent,
          meta: {
            title: "Quizy",
          },
        },
        {
          path: "/wypozyczalnia-narzedzi",
          name: "Tools",
          component: ToolsComponent,
          meta: {
            title: "Wypożyczalnia narzędzi",
          },
        },
        {
          path: "/wypozyczalnia-narzedzi/:id",
          name: "Tool",
          component: ToolComponent,
          meta: {
            title: "Wypożyczalnia narzędzi",
          },
        },
        {
          path: "/wypozyczone-narzedzia",
          name: "MyTools",
          component: MyToolsComponent,
          meta: {
            title: "Wypożyczalnia narzędzi",
          },
        },
        {
          path: "/porady-prawne",
          name: "Advices",
          component: AdvicesComponent,
          meta: {
            title: "Porady prawne",
          },
        },
        {
          path: "/porady-prawne/:id",
          name: "Advice",
          component: AdviceComponent,
          meta: {
            title: "Porady prawne",
          },
        },
        {
          path: "/pliki",
          name: "Categories",
          component: CategoriesComponent,
          meta: {
            title: "Pliki",
          },
        },
        {
          path: "/pliki/:id",
          name: "Files",
          component: FilesComponent,
          meta: {
            title: "Pliki",
          },
        },
        // {
        //   path: '/nagrody-instalatora',
        //   name: 'InstalatorPrizes',
        //   component: InstalatorPrizesComponent,
        //   meta: {
        //     title: 'Nagrody instalatora'
        //   }
        // },
        // {
        //   path: '/zamowione-nagrody-instalatora',
        //   name: 'InstalatorMyPrizes',
        //   component: InstalatorMyPrizesComponent,
        //   meta: {
        //     title: 'Zamówione nagrody instalatora'
        //   }
        // },
        // {
        //   path: '/nagrody-instalatora/:id',
        //   name: 'InstalatorPrize',
        //   component: InstalatorPrizeComponent,
        //   meta: {
        //     title: 'Nagrody instalatora'
        //   }
        // },
        {
          path: "/kontakt",
          name: "Contact",
          component: ContactComponent,
          meta: {
            title: "Kontakt",
          },
        },
      ],
    },
    {
      path: "/logowanie",
      name: "AuthenticationLogin",
      component: Authentication,
      beforeEnter: GuestGuard,
      meta: {
        title: "Logowanie",
      },
    },
    {
      path: "/rejestracja",
      name: "AuthenticationRegister",
      component: Register,
      beforeEnter: GuestGuard,
      meta: {
        title: "Logowanie",
      },
    },

    {
      path: "/rejestracja/pytania",
      name: "AuthenticationRegisterQuestions",
      component: RegisterQuestions,
      beforeEnter: AuthenticationGuard,
      meta: {
        title: "Rejestracja",
      },
    },
    {
      path: "/przypomnij-haslo",
      name: "ForgetPassword",
      component: ForgetPassword,
      beforeEnter: GuestGuard,
      meta: {
        title: "Przypomnij hasło",
      },
    },
    {
      path: "/resetuj-haslo/:token",
      name: "ResetPassword",
      component: ResetPassword,
      beforeEnter: GuestGuard,
      meta: {
        title: "Resetuj hasło",
      },
    },
    {
      path: "*",
      component: NotFound,
      meta: {
        title: "Strona nie została znaleziona",
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js